import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MainContainer from '../../../components/containers/MainContainer';
import TypeMarkDetailView from './components/TypeMarkDetailView';
import {
  CLEAR_TYPE_MARKS,
  fetchDetail,
  fetchGeometry,
  fetchInstances,
  fetchSelectedDetail,
  GET_TYPE_MARK_DETAIL,
} from '@/store/actions/typemark';
import { useQueryClient } from 'react-query';
import NLeftPanel from '../../../components/NLeftPanel';
import { TypemarkContextProvider } from './TypemarkContext';
import TypeMarkModal from './components/modals/TypeMarkModal';
import { useCreateInstanceType } from './hooks/api';
import { toast } from 'sonner';

function TypeMark({ match, isRevitView }) {
  const [activeItemId, setActiveItemId] = useState(null);
  const { pagePermission } = useSelector((state) => state.auth);
  const [search, setSearch] = useState(null);
  const [filter, setFilter] = useState({ is_active: [true] });
  const [selected, setSelected] = useState({});
  const [copiedItem, setCopiedItem] = useState(null);
  const [showNewTypemarkDialog, setShowNewTypemarkDialog] = useState(false);
  const queryClient = useQueryClient();
  const queryKey = 'instance-type';

  const { detail, geometry, menuId } = useSelector((state) => state.typeMark);
  const { modelId, contract } = useSelector((state) => state.contract);
  const contractId = contract?.id ?? null;
  const createInstanceType = useCreateInstanceType();

  const dispatch = useDispatch();

  useEffect(() => {
    setSelected({});
    setActiveItemId(null);

    if (menuId && contractId) {
      queryClient.invalidateQueries(queryKey);
      dispatch({ type: CLEAR_TYPE_MARKS });
    }
  }, [menuId, contractId]);

  useEffect(() => {
    const selectedIds = Object.values(selected);

    if (!selectedIds.length) {
      getDetail(match.params.id ?? activeItemId);
    } else if (selectedIds.length === 1) {
      getDetail(selectedIds[0]);
    } else {
      dispatch(fetchSelectedDetail(selectedIds));
    }
  }, [selected, match?.params?.id]);

  const getDetail = (id) => {
    if (!id) {
      return;
    }
    dispatch({ type: GET_TYPE_MARK_DETAIL });
    dispatch(fetchDetail(id));
    dispatch(fetchGeometry(id));
    dispatch(fetchInstances(id, 1, 10));
    setActiveItemId(id);
  };

  const handleSubmitTypeMarkDialog = (values) => {
    createInstanceType.mutate(
      {
        data: {
          ...values.values,
          model: modelId,
          contract: contractId,
        },
      },
      {
        onSuccess: () => {
          toast.success('Typemark byl úspěšně vytvořen');
          setShowNewTypemarkDialog(false);
          queryClient.invalidateQueries(queryKey);
        },
        onError: (err) => {
          console.error(err);
        },
      }
    );
  };

  const onSearch = async (e) => {
    setSearch(e?.target?.value);
  };

  if (isRevitView) {
    return (
      <TypeMarkDetailView
        data={detail}
        activeItemId={activeItemId}
        geometry={geometry}
        permission={pagePermission}
        // makeEditable={editDetail}
        isRevitView
      />
    );
  }

  return (
    <TypemarkContextProvider
      value={{
        search,
        filter,
        setSearch,
        setFilter,
        selected,
        setSelected,
        copiedItem,
        setCopiedItem,
      }}
    >
      <MainContainer>
        <NLeftPanel
          queryKey={queryKey}
          makeActive={getDetail}
          active={activeItemId}
          onSearch={onSearch}
          addItem={() => setShowNewTypemarkDialog(true)}
          title="Typemarky"
          permission={pagePermission}
          filteredValues={{
            is_active: [
              { value: true, title: 'Aktivní' },
              { value: false, title: 'Neaktivní' },
            ],
          }}
        />

        {activeItemId && (
          <TypeMarkDetailView activeItemId={activeItemId} permission={pagePermission} />
        )}

        {showNewTypemarkDialog && (
          <TypeMarkModal
            title="Vytvořit typemark"
            visible={showNewTypemarkDialog}
            onClose={() => setShowNewTypemarkDialog(false)}
            onSubmit={(values) => handleSubmitTypeMarkDialog(values)}
          />
        )}
      </MainContainer>
    </TypemarkContextProvider>
  );
}

export default TypeMark;
